import { ApolloClient } from 'apollo-client';
import * as React from 'react';
import { ApolloProvider } from 'react-apollo';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App';

/** Root component for the client-side application */
const BrowserRoot = ({ apolloClient }: { apolloClient: ApolloClient<any> }) => (
    <ApolloProvider client={apolloClient}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </ApolloProvider>
);

export default BrowserRoot;



// WEBPACK FOOTER //
// ./src/client/BrowserRoot.tsx